import { useMemo } from 'react';
import { FormSection } from 'redux-form';

import { zones as zonesService } from 'services/zones';
import { ZonesTabs } from '../blocks/zones-tabs';
import { HourlyDayNightTariffication } from './hourly-day-night-tariffication';
import { Content } from './hourly-day-night.styled';

export const TarrificatorHourlyDayNight = (props) => {
  const { selectedZone, setZone, disabled } = props;
  const zones = useMemo(() => zonesService.getZones(), []);

  const getTabs = () => {
    if (!selectedZone) {
      return null;
    }

    return zones.map((zone) => {
      return (
        <FormSection key={zone.id} name={zone.id}>
          <HourlyDayNightTariffication color={zone.background_color} display={selectedZone === zone.id} name={zone.id} disabled={disabled} />
        </FormSection>
      );
    });
  };

  const tabsEl = getTabs();

  return (
    <Content>
      <ZonesTabs setZone={setZone} activeZone={selectedZone} />
      {tabsEl}
    </Content>
  );
};
